module.exports = __webpack_public_path__ + "img/Travel-Related.9d3de639.svg";